import { render } from "./TicketDelete.vue?vue&type=template&id=1e9aeec8"
import script from "./TicketDelete.vue?vue&type=script&lang=js"
export * from "./TicketDelete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__